import Vue from 'vue';
import axios from 'axios';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en-default', // set locale
  fallbackLocale: 'en',
  silentTranslationWarn: true,
});

export default i18n;

const loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

function getLangFilename(lang: string) {
  const paths = {
    en: 'getaccept-recipient-page-en-GB',
    sv: 'getaccept-recipient-page-sv-SE',
    fr: 'getaccept-recipient-page-fr-FR',
    no: 'getaccept-recipient-page-no-NO',
    nb: 'getaccept-recipient-page-no-NO',
    nn: 'getaccept-recipient-page-no-NO',
    da: 'getaccept-recipient-page-da-DK',
    fi: 'getaccept-recipient-page-fi-FI',
    de: 'getaccept-recipient-page-de-DE',
    th: 'getaccept-recipient-page-th-TH',
    pl: 'getaccept-recipient-page-pl-PL',
    es: 'getaccept-recipient-page-es-ES',
    it: 'getaccept-recipient-page-it-IT',
    pt: 'getaccept-recipient-page-pt-PT',
    ru: 'getaccept-recipient-page-ru-RU',
  };

  return paths[lang] || paths['en'];
}

export function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      const filePath = getLangFilename(lang);
      return import(
        /* webpackChunkName: "lang-[request]" */ `@signing-page/i18n/generated/${filePath}`
      )
        .then(msgs => {
          i18n.setLocaleMessage(lang, msgs.default);
          loadedLanguages.push(lang);
          return setI18nLanguage(lang);
        })
        .catch(e => {
          console.log(e);
        });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}

export function userLanguage(): string {
  try {
    const lang = window.navigator['userLanguage'] || window.navigator.language;
    return lang.substring(0, 2);
  } catch (e) {
    return 'en';
  }
}
